/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export class DeviceEquipmentDetailsInputData {
  discipline: string;
  category: string;
  partType: string; 
  connectorCount : number;
  unit: DisplayUnit;
  returnCode : DeviceEquipmentDetailsReturnCodes
}

export enum DisplayUnit {
  Metric = 0,
  Imperial = 1
}

export enum DeviceEquipmentDetailsReturnCodes
{
  Success = 0,
  SelectionMismatchEquipment = 1,
  FamilyNotExists = 2,
  ValidSelection = 3,
  NoMessage = 4
};

export class DeviceEquipmentDetailsDataToApply {
  discipline: string;
  category: string;
  partType: string;
  manufacturer: string;
  model: string;
  nominalSize: string;
  addedWireLength: string;
  connectors: string;
  pdfLocation: string;

  constructor() {
    this.discipline = '';
    this.category = '';
    this.partType = ''; 
    this.manufacturer = '';
    this.model = '';
    this.nominalSize = '';
    this.addedWireLength = '';
    this.connectors = '';
    this.pdfLocation = '';
  }
}